module.exports = __webpack_public_path__ + "static/media/lock-star.ba1ef08b.svg";